import React, { useState, useEffect } from 'react';
import FilterColumn from '../FilterColumn';
import { Button } from '@mui/material';
import { Typography } from '@mui/material';
import { TicketButton, NextButton, StyledInput } from '../../Common/MUIStyledComponents';
import Modal from 'react-modal';
import DataSearchAPI from 'api/DataSearch';
import { useSnackbar } from 'notistack';
import { Grid, Card } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import { CardActions } from '@mui/material';
import SelectionsBadge from '../SelectionsBadge';
import { Pagination } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { fontWeight } from 'html2canvas/dist/types/css/property-descriptors/font-weight';

interface IFilterOptions {
  setFilterMode: any;
  chapterOpts: any;
  sectionOpts: any;
  codeOpts: any;
  hsCodeListOpts: any;
  totalRecords: number;
  submit: any;
  setSubmit: any;
  commodityState: any;
  setCommodityState: any;
  handleClear: any;
  inputs: any;
  appliedFilter: any;
  setAppliedFilter: any;
  filters: any;
  setFilters: any;
  cur_user: any;
}

const CommodityCodeFilterOptions: React.FC<IFilterOptions> = ({ inputs, commodityState, setCommodityState, setFilterMode, hsCodeListOpts, sectionOpts, chapterOpts, codeOpts, totalRecords, submit, setSubmit, handleClear, appliedFilter, setAppliedFilter, filters, setFilters, cur_user }) => {
  const { hsCodeLists, sections, chapters, codes } = commodityState;

  const { enqueueSnackbar } = useSnackbar();

  const [ tab, setTab ] = useState('Selections');
  const [ filterName, setFilterName ] = useState<string>('');
  const [ filterNameOpen, setFilterNameOpen ] = useState(false);
  const [ pageCount, setPageCount ] = useState<number>(1);
  const [ currentPage, setCurrentPage ] = useState(1);
  const [ currentItems, setCurrentItems ] = useState<any[]>([]);
  const resultsPerPage = 6;

  const handlePageChange = (e: any, new_page: number) => {
    setCurrentPage(new_page);
    const indexOfLastItem = new_page * resultsPerPage;
    const indexOfFirstItem = indexOfLastItem - resultsPerPage;
    setCurrentItems(filters.arr.slice(indexOfFirstItem, indexOfLastItem));
  };


  const handleFilterNameChange = (e: any) => {
    setFilterName(e.target.value);
  };

  const handleFilterNameClose = () => {
    setFilterNameOpen(false);
    setFilterName('');
  };

  const handleApply = () => {
    setSubmit({
      trigger: !submit.trigger,
      reason: 'apply',
      location: 'Commodity'
    });
    setFilterMode(false);
  };

  const handleTabSwitch = (newTab: string) => {
    switch (newTab) {
    case 'Selections':
      setTab('Selections');
      break;
    case 'Saved':
      setTab('Saved');
      break;
    default:
      setTab('Selections');
    }
  };

  const saveCodeFilter = async() => {
    const query = {
      userId: cur_user.basics.id,
      groupId: cur_user.selected_team.id,
      filterName: filterName,
      type: 'commodityCode',
      hsCodeLists: commodityState.hsCodeLists,
      sections: commodityState.sections,
      chapters: commodityState.chapters,
      codes: commodityState.codes,
      entRes: commodityState.fuzzy,
    };
    const res = await DataSearchAPI.createSearchFilter({ newSearchFilter: query });
    if (res?.success) {
      setFilters({ isLoaded: true, arr: [ ...filters.arr, res?.result ] });
      setAppliedFilter(res?.result);
      setTab('Saved');
      enqueueSnackbar('Successfully saved your filter', { variant: 'success' });
    } else if (res) {
      const error_msg = 'Error saving your filter, please try again or contact the bite team if the issue persist.';
      enqueueSnackbar(error_msg, { variant: 'error' });
    }
  };

  const updateFilter = async() => {
    setFilters({ ...filters, isLoaded: false });
    const query = {
      ...appliedFilter,
      hsCodeLists: commodityState.hsCodeLists,
      sections: commodityState.sections,
      chapters: commodityState.chapters,
      codes: commodityState.codes,
      entRes: commodityState.fuzzy,
    };
    const res = await DataSearchAPI.updateSearchFilter({ update: query });
    if (res?.success) {
      const index = filters.arr.map((filt: any, i: number) => {
        if (filt._id === res.result._id) {
          return i;
        }
      });
      const array = [ ...filters.arr ];
      array[index[0]] = res.result;
      setFilters({ isLoaded: true, arr: array });
      enqueueSnackbar('Successfully updated your filter', { variant: 'success' });
    } else {
      const error_msg = 'Error updating your filter, please try again or contact the bite team if the issue persist.';
      enqueueSnackbar(error_msg, { variant: 'error' });
    }
  };

  const deleteFitler = async(id: string) => {
    const res = await DataSearchAPI.deleteSearchFilter(id);
    if (res?.success) {
      const arr = filters.arr.filter((filt: any) => {
        return filt._id !== id;
      });
      setFilters({ isLoaded: true, arr: arr });
      enqueueSnackbar('Successfully deleted your filter', { variant: 'success' });
    } else {
      const error_msg = 'Error deleting your filter, please try again or contact the bite team if the issue persist.';
      enqueueSnackbar(error_msg, { variant: 'error' });
    }
  };

  const applyCodeFilter = async(filter: any) => {
    setCommodityState({
      ...commodityState,
      hsCodeLists: filter.hsCodeLists,
      sections: filter.sections,
      chapters: filter.chapters,
      codes: filter.codes,
      fuzzy: filter.entRes,
    });
    setSubmit({ reason: 'apply', trigger: !submit.trigger });
    setAppliedFilter(filter);
    setFilterMode(false);
  };

  useEffect(() => {
    const indexOfLastItem = currentPage * resultsPerPage;
    const indexOfFirstItem = indexOfLastItem - resultsPerPage;
    setCurrentItems(filters.arr.slice(indexOfFirstItem, indexOfLastItem));
    const totalPages = Math.ceil(filters.arr.length / resultsPerPage);
    if (totalPages === 0) {
      setPageCount(1);
    } else {
      setPageCount(totalPages);
    }
  }, [ filters ]);

  return (
    <div className='filter-options-container'>
      <div className='filter-options-header'>
        <div className='filter-options-header-content'>
          <div className='filter-options-header-icon'>
            <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
              <path d='M6 12H18M3 6H21M9 18H15' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </div>
          <div className='filter-options-header-text-group'>
            <div className='filter-options-header-text-primary'>
              {Object.keys(appliedFilter).length > 1 ? appliedFilter.filterName : 'HS Code Filter'}
            </div>
            <div className='filter-options-header-inputs-frame'>
              <div className='filter-options-header-inputs-primary'>
                Current Search: &nbsp;
              </div>
              {inputs.length > 0 && inputs[0].primary !== '' ? (
                <div className='filter-options-header-inputs-secondary'>
                  {inputs.map((input: any) => (
                    `${input.primary }, `
                  ))
                  }
                </div>
              ) : (
                <div className='filter-options-header-inputs-secondary'>
                N/A
                </div>
              )}
            </div>
            <div className='filter-options-header-text-secondary'>
              {totalRecords} records found
            </div>
          </div>
        </div>
        <div className='filter-options-header-close' onClick={() => setFilterMode(false)}>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path d='M18 6L6 18M6 6L18 18' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
      </div>
      <div className='filter-modal-tabs-container'>
        <div className='screening-tabs-inner'>
          <div
            className={`screening-tab-btn${tab === 'Selections' ? '-selected' : ''
            }`}
            onClick={() => handleTabSwitch('Selections')}
          >
            <div
              className={`screening-tab-btn-text${tab === 'Selections' ? '-selected' : ''
              }`}
            >
              Selections
            </div>
          </div>
          <div
            className={`screening-tab-btn${tab === 'Saved' ? '-selected' : ''
            }`}
            onClick={() => handleTabSwitch('Saved')}
          >
            <div
              className={`screening-tab-btn-text${tab === 'Saved' ? '-selected' : ''
              }`}
            >
              Saved Filters
            </div>
          </div>
        </div>
      </div>
      {tab === 'Selections' ?
        <>
          <div className='filter-options-body-container'>
            {/* Lists */}
            <FilterColumn location='Commodity' state={commodityState} type={'hsCodeLists'} selections={hsCodeLists} setSelections={setCommodityState} options={hsCodeListOpts.data} loading={hsCodeListOpts.isLoading} title='HS Code List' submit={submit} setSubmit={setSubmit} icon={<svg xmlns='http://www.w3.org/2000/svg' width='19' height='18' viewBox='0 0 19 18' fill='none'>
              <path d='M16.5616 11.5058C14.4443 13.0121 11.6671 13.1794 9.40777 12M2.43833 6.49417C4.56079 4.98425 7.34633 4.81978 9.60862 6.00862M12.0303 10.5933C14.1953 9.22876 15.4489 6.7306 15.2007 4.13417M6.93638 7.42778C4.79174 8.79682 3.55219 11.2827 3.79908 13.8658M12.1452 7.60278C12.0454 5.04638 10.5087 2.71263 8.13658 1.62917M6.85671 10.4442C6.97334 12.9822 8.50571 15.294 10.8633 16.3708M14.8033 3.6967C17.7322 6.62563 17.7322 11.3744 14.8033 14.3033C11.8744 17.2322 7.12562 17.2322 4.1967 14.3033C1.26777 11.3744 1.26777 6.62562 4.1967 3.6967C7.12563 0.767767 11.8744 0.767767 14.8033 3.6967ZM11.6213 6.87868C12.7929 8.05025 12.7929 9.94975 11.6213 11.1213C10.4497 12.2929 8.55025 12.2929 7.37868 11.1213C6.20711 9.94975 6.20711 8.05025 7.37868 6.87868C8.55025 5.70711 10.4497 5.70711 11.6213 6.87868Z' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>}
            />
            <FilterColumn location='Commodity' state={commodityState} type={'sections'} selections={sections} setSelections={setCommodityState} options={sectionOpts.data} loading={sectionOpts.isLoading} title='Section' submit={submit} setSubmit={setSubmit} icon={<svg xmlns='http://www.w3.org/2000/svg' width='19' height='18' viewBox='0 0 19 18' fill='none'>
              <path d='M10.5 5.62478L8.25 7.87478L11.25 9.37478L9 11.6248M15.75 8.99978C15.75 12.6811 11.7345 15.3586 10.2735 16.2109C10.1074 16.3078 10.0244 16.3562 9.90726 16.3814C9.81633 16.4009 9.68367 16.4009 9.59274 16.3814C9.47557 16.3562 9.39255 16.3078 9.22651 16.2109C7.76547 15.3586 3.75 12.6811 3.75 8.99978V5.41298C3.75 4.81335 3.75 4.51353 3.84807 4.25581C3.93471 4.02814 4.07549 3.82499 4.25824 3.66393C4.46512 3.48161 4.74585 3.37634 5.3073 3.16579L9.32865 1.65779C9.48457 1.59932 9.56253 1.57008 9.64274 1.55849C9.71388 1.54821 9.78612 1.54821 9.85726 1.55849C9.93747 1.57008 10.0154 1.59932 10.1713 1.65779L14.1927 3.16579C14.7542 3.37634 15.0349 3.48161 15.2418 3.66393C15.4245 3.82499 15.5653 4.02814 15.6519 4.25581C15.75 4.51353 15.75 4.81335 15.75 5.41298V8.99978Z' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>}
            />
            <FilterColumn location='Commodity' state={commodityState} type={'chapters'} selections={chapters} setSelections={setCommodityState} options={chapterOpts.data} loading={chapterOpts.isLoading} title='Chapter' submit={submit} setSubmit={setSubmit} icon={<svg xmlns='http://www.w3.org/2000/svg' width='19' height='18' viewBox='0 0 19 18' fill='none'>
              <path d='M8.5 3.375H13.975C14.8151 3.375 15.2351 3.375 15.556 3.53849C15.8382 3.6823 16.0677 3.91177 16.2115 4.19401C16.375 4.51488 16.375 4.93492 16.375 5.775V6.75C16.375 7.44891 16.375 7.79837 16.2608 8.07403C16.1086 8.44157 15.8166 8.73358 15.449 8.88582C15.1734 9 14.8239 9 14.125 9M10 14.625H4.525C3.68492 14.625 3.26488 14.625 2.94401 14.4615C2.66177 14.3177 2.4323 14.0882 2.28849 13.806C2.125 13.4851 2.125 13.0651 2.125 12.225V11.25C2.125 10.5511 2.125 10.2016 2.23918 9.92598C2.39142 9.55843 2.68343 9.26642 3.05097 9.11418C3.32663 9 3.67609 9 4.375 9M7.975 10.875H10.525C10.735 10.875 10.84 10.875 10.9202 10.8341C10.9908 10.7982 11.0482 10.7408 11.0841 10.6702C11.125 10.59 11.125 10.485 11.125 10.275V7.725C11.125 7.51498 11.125 7.40997 11.0841 7.32975C11.0482 7.25919 10.9908 7.20183 10.9202 7.16587C10.84 7.125 10.735 7.125 10.525 7.125H7.975C7.76498 7.125 7.65997 7.125 7.57975 7.16587C7.50919 7.20183 7.45183 7.25919 7.41587 7.32975C7.375 7.40997 7.375 7.51498 7.375 7.725V10.275C7.375 10.485 7.375 10.59 7.41587 10.6702C7.45183 10.7408 7.50919 10.7982 7.57975 10.8341C7.65997 10.875 7.76498 10.875 7.975 10.875ZM13.6 16.5H16.15C16.36 16.5 16.465 16.5 16.5452 16.4591C16.6158 16.4232 16.6732 16.3658 16.7091 16.2952C16.75 16.215 16.75 16.11 16.75 15.9V13.35C16.75 13.14 16.75 13.035 16.7091 12.9548C16.6732 12.8842 16.6158 12.8268 16.5452 12.7909C16.465 12.75 16.36 12.75 16.15 12.75H13.6C13.39 12.75 13.285 12.75 13.2048 12.7909C13.1342 12.8268 13.0768 12.8842 13.0409 12.9548C13 13.035 13 13.14 13 13.35V15.9C13 16.11 13 16.215 13.0409 16.2952C13.0768 16.3658 13.1342 16.4232 13.2048 16.4591C13.285 16.5 13.39 16.5 13.6 16.5ZM2.35 5.25H4.9C5.11002 5.25 5.21503 5.25 5.29525 5.20913C5.36581 5.17317 5.42317 5.11581 5.45913 5.04525C5.5 4.96503 5.5 4.86002 5.5 4.65V2.1C5.5 1.88998 5.5 1.78497 5.45913 1.70475C5.42317 1.63419 5.36581 1.57683 5.29525 1.54087C5.21503 1.5 5.11002 1.5 4.9 1.5H2.35C2.13998 1.5 2.03497 1.5 1.95475 1.54087C1.88419 1.57683 1.82683 1.63419 1.79087 1.70475C1.75 1.78497 1.75 1.88998 1.75 2.1V4.65C1.75 4.86002 1.75 4.96503 1.79087 5.04525C1.82683 5.11581 1.88419 5.17317 1.95475 5.20913C2.03497 5.25 2.13998 5.25 2.35 5.25Z' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>}
            />
            <FilterColumn location='Commodity' state={commodityState} type={'codes'} selections={codes} setSelections={setCommodityState} options={codeOpts.data} loading={codeOpts.isLoading} title='HS Code' submit={submit} setSubmit={setSubmit} icon={<svg xmlns='http://www.w3.org/2000/svg' width='19' height='18' viewBox='0 0 19 18' fill='none'>
              <path d='M16 2.25H2.5M16 15.75H2.5M4 9C4 8.30109 4 7.95163 4.11418 7.67598C4.26642 7.30843 4.55843 7.01642 4.92598 6.86418C5.20163 6.75 5.55109 6.75 6.25 6.75L12.25 6.75C12.9489 6.75 13.2984 6.75 13.574 6.86418C13.9416 7.01642 14.2336 7.30843 14.3858 7.67598C14.5 7.95163 14.5 8.30109 14.5 9C14.5 9.69891 14.5 10.0484 14.3858 10.324C14.2336 10.6916 13.9416 10.9836 13.574 11.1358C13.2984 11.25 12.9489 11.25 12.25 11.25L6.25 11.25C5.55109 11.25 5.20163 11.25 4.92597 11.1358C4.55843 10.9836 4.26642 10.6916 4.11418 10.324C4 10.0484 4 9.69891 4 9Z' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>}
            />
          </div>
          <div className='filter-options-btns-container'>
            <div className='filter-options-btns-spacer'>
              {Object.keys(appliedFilter).length > 1 && <Button sx={{ color: '#4895EF', marginLeft: '20px' }} onClick={() => {
                updateFilter();
              }}>Update</Button>}
              <Button
                disabled={commodityState.hsCodeLists.length === 0}
                sx={{ color: '#4895EF', marginLeft: '20px' }}
                onClick={() => setFilterNameOpen(true)}
              >Save Filter</Button>
              <Button
                onClick={() => {
                  handleClear();
                }}
                sx={{ color: '#EFF1F6' }}>Clear</Button>
              <Button
                sx={{ color: '#EFF1F6', background: '#4895EF' }}
                onClick={handleApply}
              >Apply</Button>
            </div>
          </div>
        </> :
        <>
          <div className='saved-filters-container'>
            {filters.arr.length === 0 ?
              <div className='no-saved-filters-row'>
                <div className='no-saved-filters-text'>
                You have no saved Listing Filters
                </div>
              </div> :
              <Grid container spacing={2} sx={{ padding: '20px' }}>
                {currentItems.map((filt: any) =>
                  <Grid item xs={12} sm={6} md={4} key={filt._id}>
                    <Card variant='outlined' sx={{ background: appliedFilter._id === filt._id ? 'rgba(72, 149, 239, 0.15)' : '#2E3036',
                      border: appliedFilter._id === filt._id ? '1px solid #4895ef' : '1px solid transparent', borderRadius: '12px', fontFamily: 'Inter', fontSize: '18px', fontStyle: 'normal', color: '#EFF1F6', display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                      <React.Fragment>
                        <CardContent>
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography sx={{ fontFamily: 'Inter', fontSize: '18px', fontStyle: 'normal', color: '#EFF1F6', fontWeight: 600 }} component='div' noWrap>
                              {filt.filterName}
                            </Typography>
                            <DeleteOutlineIcon onClick={() => deleteFitler(filt._id)} sx={{ color: '#BDBEC1', cursor: 'pointer' }} />
                          </div>
                          <Typography sx={{ display: 'flex', gap: '12px', fontFamily: 'Inter', fontStyle: 'normal', color: '#EFF1F6', }}>Selected Lists: <SelectionsBadge selections={filt.hsCodeLists} />
                          </Typography>
                          <Typography variant='body2' sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis', fontFamily: 'Inter', fontStyle: 'normal', color: '#EFF1F6',
                          }}>
                       Sections: {filt.sections.length > 0 ? filt.sections.join(', ') : ''}
                          </Typography>
                        </CardContent>
                        <CardActions>
                          {appliedFilter._id !== filt._id && <Button onClick={() => applyCodeFilter(filt)} size='small'>Apply Filter</Button>}
                        </CardActions>
                      </React.Fragment>
                    </Card>
                  </Grid>
                )}
              </Grid>
            }
            <div className='screening-results-footer'>
              <div className='screening-results-pagination-text'>
             Page {currentPage} of {pageCount}
              </div>
              <div className='screening-results-footer-action-group'>
                <div className='hb-pagination'>
                  <Pagination
                    onChange={handlePageChange}
                    size='large'
                    count={pageCount}
                    shape='rounded'
                    variant='text'
                    page={currentPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      }
      <Modal
        isOpen={filterNameOpen}
        onRequestClose={handleFilterNameClose}
        ariaHideApp={false}
      >
        <div className='bite-score-file-modal'>
          <div className='display-flex justify-between width-100'>
            <Typography variant='h5'>Filter Name:</Typography>
            <TicketButton onClick={handleFilterNameClose} className='cursor-pointer'/>
          </div>
          <div className='display-flex justify-end width-100'>
            <StyledInput
              value={filterName}
              onChange={handleFilterNameChange}
              variant='outlined'
              className='margin-right-20px'
            />
            <NextButton variant='contained' color='primary'
              onClick={() => {
                saveCodeFilter();
                handleFilterNameClose();
              }
              }>Save</NextButton>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default CommodityCodeFilterOptions;
